/**
 * Book a call. Verbatim from design/Homepage.dc.html lines 424-461.
 *
 * The shared brief posts to the contact endpoint after email confirmation.
 */

export const bookSection = {
  eyebrow: "Book a call",
  heading: "Schedule an engineering call.",
  /**
   * Client rewrite, 2026-08-17. The reference reads "with a senior engineer, not
   * a sales team". Also renders on /services/ai-driven-validation, the one page
   * using the shared ServiceCta.
   */
  lead: "Thirty minutes with an engineering team, not a sales. Bring a release problem, a compliance deadline or an AI feature you cannot yet trust.",
} as const;

export const scheduler = { label: "Schedule an Engineering Call" } as const;

export const briefForm = {
  title: "Or send the brief first",
  fields: [
    {
      name: "name",
      label: "Name",
      type: "text" as const,
      placeholder: "Your name",
      autoComplete: "name",
    },
    {
      name: "email",
      label: "Work email",
      type: "email" as const,
      placeholder: "name@company.com",
      autoComplete: "email",
    },
    {
      name: "company",
      label: "Company & sector",
      type: "text" as const,
      placeholder: "Company · FinTech / Healthcare / eCommerce",
      autoComplete: "organization",
    },
  ],
  message: {
    name: "message",
    label: "What do you need?",
    placeholder: "Describe your project, the problem you want to solve, and the help you need.",
    rows: 4,
  },
  submit: "Send the brief",
  note: "We reply within one business day. Rotterdam · Kraków · Lviv.",
  /**
   * The email-code step, added 2026-10-11 against bot briefs: nothing reaches
   * the team until the code mailed to the work email is entered. New copy,
   * pending sign-off. `{email}` and `{minutes}` are filled in by the form.
   */
  verify: {
    sending: "Sending the code…",
    eyebrow: "Check your inbox",
    title: "Enter the 6-digit code",
    lead: "We sent it to {email}. Your brief goes to the team as soon as the code is in.",
    label: "Confirmation code",
    submit: "Confirm and send the brief",
    submitting: "Checking…",
    resend: "Send a new code",
    resendIn: "New code in {seconds}s",
    resent: "A new code is on its way.",
    edit: "Edit the brief",
    note: "The code works for {minutes} minutes. Not there? Check spam or promotions.",
  },
} as const;
